'use strict';

var control = require('unified-message-control');
var marker = require('mdast-comment-marker');
var xtend = require('xtend');

module.exports = messageControl;

function messageControl(options) {
  var settings = options || {};

  return control(xtend(options, {
    marker: settings.marker || marker,
    test: settings.test || 'html'
  }));
}



//////////////////
// WEBPACK FOOTER
// ./~/remark-message-control/index.js
// module id = 246
// module chunks = 94053359063892 107818501498521